import { styled } from "goober";
import { Button } from "./Button";
import { ButtonLink } from "./Button/ButtonLink";

export const SubtleButton = styled(Button)`
  &.secondary {
    color: var(--text-secondary);
  }
`;

export const SubtleButtonLink = styled(ButtonLink)`
  &.secondary {
    color: var(--text-secondary);
  }
`;
